<template>
  <div>
    <v-form @submit.prevent v-model="valid">
      <v-text-field
        v-model="merchantId"
        label="ID do Estabelecimento"
        required
        type="tel"
        outlined
        :disabled="loading"
        :rules="[(v) => uuidRegex.test(v) || 'ID do Estabelecimento inválido']"
      />
      <v-text-field
        v-model="merchantKey"
        label="Chave do Estabelecimento"
        required
        type="tel"
        outlined
        :disabled="loading"
        :rules="[(v) => v.length >= 40 || 'Chave do Estabelecimento inválida']"
      />
      <v-card outlined class="pa-3">
        <b class="d-block mb-3">Dados para 3DS</b>
        <v-text-field
          v-model="merchantName"
          label="Nome do Estabelecimento"
          required
          type="tel"
          outlined
          :disabled="loading"
          :rules="[(v) => v.length > 0 || 'Nome do Estabelecimento inválido']"
        />
        <v-text-field
          v-model="clientId3ds"
          label="Client ID 3DS"
          required
          type="tel"
          outlined
          :disabled="loading"
          :rules="[(v) => uuidRegex.test(v) || 'Client ID 3DS inválido']"
        />
        <v-text-field
          v-model="clientSecret3ds"
          label="Client Secret 3DS"
          required
          type="tel"
          outlined
          :disabled="loading"
          :rules="[(v) => v.length > 40 || 'Client Secret 3DS inválido']"
        />
        <v-text-field
          v-model="establishmentCode"
          label="Código do Estabelecimento"
          required
          placeholder="1234567890"
          type="tel"
          outlined
          :disabled="loading"
          :rules="[
            (v) => v.length >= 10 || 'Código do Estabelecimento inválido',
          ]"
        />
        <v-text-field
          v-model="establishmentMcc"
          label="MCC do Estabelecimento"
          required
          placeholder="5912"
          type="tel"
          outlined
          :disabled="loading"
          :rules="[(v) => v.length >= 3 || 'MCC do Estabelecimento inválido']"
          hide-details="auto"
        />
      </v-card>

      <v-alert v-if="error" type="error" text>
        {{ error }}
      </v-alert>

      <v-alert type="info" text class="mt-3">
        Não será verificado se os dados estão corretos. Confira os dados antes de
        salvar.
      </v-alert>

      <v-btn
        color="primary"
        @click="save"
        :disabled="!valid"
        :loading="loading"
      >
        Salvar
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import platformService from "@/services/admin/platform";

const keys = [
  "clientId3ds",
  "clientSecret3ds",
  "establishmentCode",
  "establishmentMcc",
  "merchantId",
  "merchantKey",
  "merchantName",
];

export default {
  name: "CieloSettings",
  props: {
    platform: {
      type: Object,
      required: true,
    },
    gateways: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      error: null,
      valid: false,
      loading: false,

      clientId3ds: "",
      clientSecret3ds: "",
      establishmentCode: "",
      establishmentMcc: "",
      merchantId: "",
      merchantKey: "",
      merchantName: "",

      uuidRegex:
        /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,
    };
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        this.error = null;
        const response = await platformService.updateGateway(
          this.platform.id,
          "cielo",
          {
            merchantId: this.merchantId,
            merchantKey: this.merchantKey,
            merchantName: this.merchantName,
            clientId3ds: this.clientId3ds,
            clientSecret3ds: this.clientSecret3ds,
            establishmentCode: this.establishmentCode,
            establishmentMcc: this.establishmentMcc,
          }
        );

        this.$emit("update:valid", true);
      } catch (error) {
        this.error = error.message || "Erro ao salvar configurações";
        this.$emit("update:valid", false);
      } finally {
        this.loading = false;
      }
    },
    load() {
      this.merchantName = this.gateways.cielo.merchantName;
      this.merchantId = this.gateways.cielo.merchantId;
      this.merchantKey = this.gateways.cielo.merchantKey;
      this.clientId3ds = this.gateways.cielo.clientId3ds;
      this.clientSecret3ds = this.gateways.cielo.clientSecret3ds;
      this.establishmentCode = this.gateways.cielo.establishmentCode;
      this.establishmentMcc = this.gateways.cielo.establishmentMcc;

      const hasAllKeys = keys.every((key) => this.gateways.cielo[key]);

      this.$emit("update:valid", hasAllKeys);
    },
  },
  watch: {
    ...keys.map((key) => ({
      [key]: {
        handler(val) {
          console.log(val);
          this.$emit("update:valid", false);
        },
        immediate: true,
      },
    })),
    gateways: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
  },
};
</script>
